import { css } from '@emotion/react';
import { button } from '~/styles/buttons';

export const h1 = ({ theme }) => css`
    font-family: ${theme.typography.h1.fontFamily};
    font-weight: ${theme.typography.h1.fontWeight};
    font-size: 3.2rem;
    line-height: 0.96;
    letter-spacing: 0.8px;

    @media (min-width: ${theme.breakpoints.tablet}) {
        line-height: 1.1;
        font-size: ${theme.typography.h1.fontSize};
    }
`;

export const h2 = ({ theme }) => css`
    font-family: ${theme.typography.h2.fontFamily};
    font-weight: ${theme.typography.h2.fontWeight};
    font-size: 3.2rem;
    line-height: 1.125;

    @media (min-width: ${theme.breakpoints.tablet}) {
        font-size: ${theme.typography.h2.fontSize};
        line-height: 1.222;
    }
`;

export const h3 = ({ theme }) => css`
    font-family: ${theme.typography.h3.fontFamily};
    font-weight: ${theme.typography.h3.fontWeight};
    font-size: 2.8rem;
    line-height: 1.3;
    letter-spacing: 0.6px;

    @media (min-width: ${theme.breakpoints.tablet}) {
        font-size: ${theme.typography.h3.fontSize};
        line-height: 1.4;
    }
`;

export const h4 = ({ theme }) => css`
    font-family: ${theme.typography.h4.fontFamily};
    font-weight: ${theme.typography.h4.fontWeight};
    font-size: ${theme.typography.h4.fontSize};
    line-height: 1.3;
`;

export const p = ({ theme, darkBackground }) => css`
    font-family: ${theme.typography.p.fontFamily};
    font-weight: ${theme.typography.p.fontWeight};
    font-size: 1.6rem;
    line-height: 1.5;
    margin-bottom: ${theme.layout.paragraphSpacing};
    letter-spacing: 0.3px;

    a {
        color: ${darkBackground ? theme.palette.white : theme.palette.darkBlue};
        text-decoration: underline;
        transition: color ${theme.animation.duration.medium};

        &:hover,
        &:focus {
            color: ${darkBackground
                ? theme.palette.lightBlue
                : theme.palette.mediumBlue};
        }
    }

    @media (min-width: ${theme.breakpoints.tablet}) {
        font-size: ${theme.typography.p.fontSize};
        line-height: 1.55;
    }
`;

export const li = ({ theme }) => css`
    ${p({ theme })};
    line-height: 1.4;
`;

export const ul = ({ theme }) => css`
    list-style-type: disc;
    padding-left: 25px;

    li {
        ${li({ theme })};
    }
`;

export const ol = ({ theme }) => css`
    list-style-type: decimal;
    padding-left: 25px;
    li {
        ${li({ theme })};
    }
`;

export const smallText = ({ theme }) => css`
    font-family: ${theme.typography.p.fontFamily};
    font-weight: ${theme.typography.p.fontWeight};
    font-size: 1.4rem;
    line-height: 1.3;

    @media (min-width: ${theme.breakpoints.tablet}) {
        font-size: 1.6rem;
        line-height: 1.4;
    }
`;

export const smallerText = ({ theme }) => css`
    font-family: ${theme.typography.p.fontFamily};
    font-weight: ${theme.typography.p.fontWeight};
    font-size: 1.3rem;
    line-height: 1.3;

    @media (min-width: ${theme.breakpoints.tablet}) {
        font-size: 1.4rem;
        line-height: 1.4;
    }
`;

export const a = ({ theme, darkBackground }) => css`
    text-decoration: none;
    color: ${darkBackground ? theme.palette.white : theme.palette.darkBlue};

    &:hover,
    &:focus {
        text-decoration: underline;
    }

    &.button {
        color: ${theme.palette.white};
        text-decoration: none;
        display: inline-block;
        ${button({ theme })};

        &:hover,
        &:focus {
            color: ${theme.palette.white};
        }
    }
`;

export const eyebrowLabel = ({ theme }) => css`
    font-family: ${theme.typography.fontFamily.heading};
    font-weight: ${theme.typography.fontWeight.bold};
    color: ${theme.palette.tuscany};
    font-size: 2rem;
    letter-spacing: 0.63px;
    text-transform: uppercase;
`;

export const underlineHover = ({ theme }) => css`
    position: relative;

    &:after {
        content: '';
        position: absolute;
        bottom: -0.2em;
        left: 0;
        width: 0;
        height: 1px;
        background-color: ${theme.palette.mediumBlue};
        transition: width ${theme.animation.duration.fast} ease-in-out;
    }

    &:hover,
    &:focus {
        > i {
            margin-left: 10px;
        }
        &:after {
            width: 100%;
        }
    }
`;
